import { calculatePeriodDates } from '../../utils/dateUtils';

export const calculateOutgoing = (trackingPeriod, state) => {
  let outgoingAmount = 0;

  if (trackingPeriod === 'current-week') {
    outgoingAmount = parseFloat(state.totals.totalThisWeek || 0);
  } else if (trackingPeriod === 'current-fortnight') {
    const firstWeekStart = new Date(state.fortnightDates.firstWeekStart);
    const firstWeekEnd = new Date(state.fortnightDates.firstWeekEnd);
    const secondWeekStart = new Date(state.fortnightDates.secondWeekStart);
    const secondWeekEnd = new Date(state.fortnightDates.secondWeekEnd);

    const firstWeekBills = (state.bills || []).filter((b) => {
      const billDate = new Date(b.due_date);
      return (
        billDate >= firstWeekStart &&
        billDate <= firstWeekEnd &&
        !b.paid &&
        b.description !== 'incoming pay'
      );
    });
    const firstWeekTotal = firstWeekBills.reduce(
      (sum, b) => sum + Math.abs(parseFloat(b.amount) || 0),
      0
    );

    const secondWeekBills = (state.bills || []).filter((b) => {
      const billDate = new Date(b.due_date);
      return (
        billDate >= secondWeekStart &&
        billDate <= secondWeekEnd &&
        !b.paid &&
        b.description !== 'incoming pay'
      );
    });
    const secondWeekTotal = secondWeekBills.reduce(
      (sum, b) => sum + Math.abs(parseFloat(b.amount) || 0),
      0
    );

    const overdueUnpaid = (state.overdueBills || []).filter((b) => !b.paid);
    const overdueTotal = overdueUnpaid.reduce(
      (sum, b) => sum + Math.abs(parseFloat(b.amount) || 0),
      0
    );

    outgoingAmount = firstWeekTotal + secondWeekTotal + overdueTotal;
  } else if (trackingPeriod === 'two-weeks') {
    const unpaidThisWeek = (state.currentWeekBills || []).filter(
      (b) => !b.paid && b.description !== 'incoming pay'
    );
    const unpaidThisWeekTotal = unpaidThisWeek.reduce(
      (sum, b) => sum + Math.abs(parseFloat(b.amount) || 0),
      0
    );
    const unpaidNextWeek = (state.nextWeekBills || []).filter(
      (b) => !b.paid && b.description !== 'incoming pay'
    );
    const unpaidNextWeekTotal = unpaidNextWeek.reduce(
      (sum, b) => sum + Math.abs(parseFloat(b.amount) || 0),
      0
    );
    const overdueUnpaid = (state.overdueBills || []).filter((b) => !b.paid);
    const overdueTotal = overdueUnpaid.reduce(
      (sum, b) => sum + Math.abs(parseFloat(b.amount) || 0),
      0
    );
    outgoingAmount = unpaidThisWeekTotal + unpaidNextWeekTotal + overdueTotal;
  } else {
    const periodInfo = calculatePeriodDates(trackingPeriod, state.fortnightDates);
    const periodStart = new Date(periodInfo.start);
    const periodEnd = new Date(periodInfo.end);

    const periodBills = (state.bills || []).filter((b) => {
      const billDate = new Date(b.due_date);
      return (
        billDate >= periodStart &&
        billDate <= periodEnd &&
        !b.paid &&
        b.description !== 'incoming pay'
      );
    });
    const periodTotal = periodBills.reduce(
      (sum, b) => sum + Math.abs(parseFloat(b.amount) || 0),
      0
    );

    const overdueUnpaid = (state.overdueBills || []).filter((b) => !b.paid);
    const overdueTotal = overdueUnpaid.reduce(
      (sum, b) => sum + Math.abs(parseFloat(b.amount) || 0),
      0
    );

    outgoingAmount = periodTotal + overdueTotal;
  }

  return outgoingAmount;
};

export const calculateIncoming = (trackingPeriod, state) => {
  let incomingTotal = 0;

  if (trackingPeriod === 'current-week') {
    incomingTotal = parseFloat(state.transferTotals.totalUnpaidPaysThisWeek || 0);
  } else if (trackingPeriod === 'current-fortnight') {
    const fortnightTransfers =
      parseFloat(state.transferTotals.totalUnpaidPaysThisWeek || 0) +
      parseFloat(state.transferTotals.totalUnpaidPaysNextWeek || 0);

    const overdueTransfers = (state.pays || []).filter((pay) => {
      if (!pay || pay.transferMade || pay.paid) return false;
      const payDate = new Date(pay.due_date || pay.next_pay);
      const currentWeekStart = new Date(state.fortnightDates.firstWeekStart);
      return payDate <= currentWeekStart;
    });
    const overdueTransfersTotal = overdueTransfers.reduce(
      (sum, t) => sum + Math.abs(parseFloat(t.amount || t.transferAmount || 0) || 0),
      0
    );

    incomingTotal = fortnightTransfers + overdueTransfersTotal;
  } else if (trackingPeriod === 'two-weeks') {
    const twoWeeksTransfers =
      parseFloat(state.transferTotals.totalUnpaidPaysThisWeek || 0) +
      parseFloat(state.transferTotals.totalUnpaidPaysNextWeek || 0);

    const overdueTransfers = (state.pays || []).filter((pay) => {
      if (!pay || pay.transferMade || pay.paid) return false;
      const payDate = new Date(pay.due_date || pay.next_pay);
      const currentWeekStart = new Date(state.fortnightDates.firstWeekStart);
      return payDate <= currentWeekStart;
    });
    const overdueTransfersTotal = overdueTransfers.reduce(
      (sum, t) => sum + Math.abs(parseFloat(t.amount || t.transferAmount || 0) || 0),
      0
    );

    incomingTotal = twoWeeksTransfers + overdueTransfersTotal;
  } else {
    const fortnightTransfers =
      parseFloat(state.transferTotals.totalUnpaidPaysThisWeek || 0) +
      parseFloat(state.transferTotals.totalUnpaidPaysNextWeek || 0);

    const overdueTransfers = (state.pays || []).filter((pay) => {
      if (!pay || pay.transferMade || pay.paid) return false;
      const payDate = new Date(pay.due_date || pay.next_pay);
      const currentWeekStart = new Date(state.fortnightDates.firstWeekStart);
      return payDate <= currentWeekStart;
    });
    const overdueTransfersTotal = overdueTransfers.reduce(
      (sum, t) => sum + Math.abs(parseFloat(t.amount || t.transferAmount || 0) || 0),
      0
    );

    incomingTotal = fortnightTransfers + overdueTransfersTotal;
  }

  return incomingTotal;
};
